import dayjs from "dayjs";

export function formatDate(dateToFormat: Date | string | null) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).format(`DD/MM/YYYY - HH:mm:ss`);
  } catch (error) {
    return `--/--/---- --:--:--`;
  }
}

/** O fuso da plataforma, o mesmo do XLSX: a tela e o arquivo mostram a mesma hora. */
const FUSO_DA_PLATAFORMA = "America/Sao_Paulo";

function partesNoFuso(em: Date | string) {
  const partes = new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZone: FUSO_DA_PLATAFORMA,
  }).formatToParts(new Date(em));
  const parte = (tipo: Intl.DateTimeFormatPartTypes) => partes.find((p) => p.type === tipo)?.value ?? "";
  return {
    data: `${parte("day")}/${parte("month")}/${parte("year")}`,
    hora: `${parte("hour")}:${parte("minute")}`,
  };
}

/** "Execução de 01/10/2026 às 09:00 concluída sem inconsistências." */
export function mensagemExecucaoSemAchados(em: Date | string) {
  const { data, hora } = partesNoFuso(em);
  return `Execução de ${data} às ${hora} concluída sem inconsistências.`;
}

/** "Execução em andamento desde 09:00" */
export function mensagemExecucaoEmAndamento(iniciadaEm: Date | string) {
  return `Execução em andamento desde ${partesNoFuso(iniciadaEm).hora}`;
}

/** "A última execução falhou; o resultado abaixo é de 20/09/2026" */
export function mensagemExecucaoFalhou(resultadoEm: Date | string | null) {
  return resultadoEm
    ? `A última execução falhou; o resultado abaixo é de ${partesNoFuso(resultadoEm).data}`
    : "A última execução falhou; não há resultado anterior.";
}

export function formatMonth(dateToFormat: Date | string | null | undefined) {
  try {
    /** `dayjs(undefined)` é agora: sem a guarda, a falta de mês virava o mês corrente. */
    if (dateToFormat === undefined || dateToFormat === null || !dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).format(`MM/YYYY`);
  } catch (error) {
    return `--/--/---- --:--:--`;
  }
}